import { gql } from '@apollo/client';
import { USER } from '../fragments';

export const GET_AUTHENTICATED_USER = gql`
  query authenticatedUser {
    authenticatedUser {
      ...user
    }
  }
  ${USER}
`;
